<template>
  <v-layout justify-center>
    <v-flex>
      <v-dialog v-model="value" persistent max-width="350px">
        <v-card>
          <v-card-title>
            <v-flex class="headline">{{user.firstName}} {{user.lastName}}</v-flex>
          </v-card-title>
          <v-card-text class="text-left">
            <v-container>
              <v-layout>
                <v-flex>
                  First Name: {{user.firstName}}<br>
                  Last Name: {{user.lastName}}<br>
                  Username: {{user.username}}<br>
                  Email: {{user.email}}<br>
                  Branch: {{user.branch}}<br>
                  Registration: {{user.registrationDate}}<br>
                  Last Login: {{user.lastLoginDate}}<br>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click.native="okClicked()">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class ViewUserDialog extends Vue {
  @Prop(Object) user;
  @Prop(Boolean) value;

  okClicked() {
    this.closeDialog();
  }

  closeDialog() {
    // This changes the 'value' Prop in the parent component to false and
    // since it is bound to the dialog's activator, will close the dialog.
    this.$emit('input', false);
  }
}
</script>
